import * as yup from "yup"
import { maxStringLength, requiredErrorMessage, } from "../../formItems/errors/yupErrorMessages"

export const addExamGroupValidationSchema = yup.object().shape({
  name: yup.string()
    .max(100, maxStringLength(100))
    .required(requiredErrorMessage),
  tenantId: yup.string().required(requiredErrorMessage)
})
